export default __webpack_public_path__ + "images/VT.72f701e.png";